"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Includes = void 0;
/**Use in place of .includes. Takes in the word, search term, and index to start from.
 *  Will default to .includes if present in String.prototype
*/

var Includes = function Includes(word, search) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!String.prototype.includes) {
    if (start + search.length > word.length) {
      return false;
    } else {
      return word.indexOf(search, start) !== -1;
    }
  } else {
    return word.includes(search);
  }
};

exports.Includes = Includes;